<template>
  <div>
    <v-btn class="btn-link" @click.native.stop="docsModal = true">
      <label :class="{ invalid: invalid, 'highlight-upload-text': highlightUploadText }">
        {{ $t("Загрузить тот или иной документ в зависимости от вида проекта НПА, выбранного выше") }}
      </label>
    </v-btn>
    <v-dialog v-model="docsModal" max-width="600">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t("Сопроводительные документы") }}
          <v-btn color="modal-close" @click.native="docsModal = false">
            <span class="pro-icon-close1"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="files">
            <div class="file-item">
              <v-row>
                <v-col cols="12" sm="12" class="col-file-input" :class="{ invalid: $v.document.file.$error }">
                  <v-file-input
                    id="npa_documents"
                    v-model="document.file"
                    label="Загрузить документ"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <textarea v-model="document.description"></textarea>
                </v-col>
                <v-col cols="12" sm="12" :class="{ invalid: $v.document.type.$error }">
                  <v-select
                    v-model="document.type"
                    label="Тип документа"
                    :items="docType"
                    item-text="transName"
                    return-object
                    persistent-hint
                    outlined
                    rounded
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-btn color="primary" dark @click="setDataDocs">
                    Добавить
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <ol class="selectTypeList">
      <li v-for="item in documentList" :key="item.type.id">
        {{ item.type.transName }}
        <span class="pro-icon-close" @click="deleteType(item.type.id)"></span>
      </li>
    </ol>
  </div>
</template>

<script>
import GET from '@/store/modules/getNpaData'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    invalid: {
      type: Boolean,
      default: false
    },
    highlightUploadText: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    docType: [],
    document: {
      description: '',
      type: '',
      file: null
    },
    documentList: [],
    docsModal: false
  }),
  validations:{
    document: {
      type: { required },
      file: { required }
    }
  },
  mounted() {
    GET.getNpaData()
      .then((response) => {
        this.docType = response.data.refDocType
      })
      .catch((error) => {})
  },
  methods: {
    deleteType(id) {
      this.documentList = this.documentList.filter(
        (item) => Number(item.type.id) !== Number(id)
      )
      this.sendDocument()
    },
    setDataDocs() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }

      this.documentList.push(this.document)
      this.sendDocument()
      this.document = {}
      this.docsModal = false
    },
    sendDocument() {
      const documentList = this.documentList
      this.$emit('setDataDocs', documentList)
    },
    resetDocument() {
      this.documentList = []
    }
  }
}
</script>

<style lang="scss">
.file-item {
  .col-12 {
    margin-bottom: 10px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .v-text-field__details {
    display: none;
  }

  textarea {
    height: 100px;
    resize: none;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
}

.form-group {
  .btn-link {
    background: transparent !important;
    font-weight: 300;
    font-size: inherit;
    color: #004581;
    padding: 0 !important;
    border: 0;
    box-shadow: none;
    text-transform: none;
    text-decoration: underline;
    letter-spacing: 0;

    .v-btn__content {
      padding: 0;
      background: inherit;
    }

    &::before {
      display: none;
    }

    &:hover {
      text-decoration: none;
    }

    label {
      cursor: pointer;
    }
  }

  .btn-link label.highlight-upload-text {
    color: #d32f2f;
    font-weight: 700;
  }
}
</style>
